"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagsSelector = void 0;
var react_1 = __importDefault(require("react"));
var inversify_react_1 = require("inversify-react");
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var MultiSelectCombobox_1 = __importDefault(require("Common/MultiSelectCombobox/MultiSelectCombobox"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
exports.TagsSelector = (0, mobx_react_1.observer)(function (_a) {
    var selectedTags = _a.selectedTags, setSelectedTags = _a.setSelectedTags, className = _a.className;
    var rootDataStore = (0, inversify_react_1.useInjection)("rootDataStore");
    var projectTags = rootDataStore.projectTagDataStore.projectTags;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(kaleidoscope_1.Label, { className: "kl-select__label", element: "div", size: "s", long: true }, "Tag"),
        react_1.default.createElement(MultiSelectCombobox_1.default, { entries: projectTags.map(function (tag) { return ({ label: tag, value: tag, data: tag }); }), selectedValues: selectedTags, setSelectedValues: setSelectedTags, label: "Search tags", placeholder: "Enter a tag", icon: react_1.default.createElement(icons_1.Tag, null) })));
});
